import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { MediaInterface } from '../../interfaces'

@Component({
  selector: 'dmmp-website-tenured-professor',
  templateUrl: './website-tenured-professor.component.html'
})
export class WebsiteTenuredProfessorComponent implements OnInit {

  @Input() identifier
  @Input() teacher
  @Input() columnsContent
  @Input() module
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Input() professorTitle
  @Input() directorTitle

  @Input() defaultClass = 'website-tenured-professor'
  medias : MediaInterface[] = [
    { style: '289x290', media: '(min-width:421px)' },
    { style: '241x256', media: '(max-width:420px)' }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
